import { render, staticRenderFns } from "./CustomPayment-SPMGA.vue?vue&type=template&id=4f7581cd&scoped=true&"
import script from "./CustomPayment-SPMGA.vue?vue&type=script&lang=js&"
export * from "./CustomPayment-SPMGA.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment-SPMGA.vue?vue&type=style&index=0&id=4f7581cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7581cd",
  null
  
)

export default component.exports